// @flow
import { withRouter } from 'react-router-dom';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import JobDetail from 'containers/job/JobDetailContainer';
import JobListContent from 'containers/job/JobListContainer';
import { type RouterProps } from 'types/Router';

function JobList({ match: { url } }: RouterProps) {
	return (
		<Switch>
			<Route
				exact
				path={`${url}${url.endsWith('/') ? '' : '/'}offre-emploi/:jobSlug`}
				component={JobDetail}
			/>

			<Route
				exact
				path={url}
				component={JobListContent}
			/>
		</Switch>
	);
}

export default withRouter(JobList);
